export interface IBracketResponse {
  rangeFrom: number;
  rangeTo: number;
  price: number;
}

export type IBracketData = IBracketResponse;

export const convertIBracketResponseToIBracketData = (response: IBracketResponse): IBracketData => ({ ...response });
